import React, { useState, useEffect } from 'react'
import pathname from '../../constants/pathname'
import ProjectDataTable from '../dataTable/ProjectDataTable'
import { useHistory } from 'react-router-dom'
import { getDept6Scrutinize } from '../../redux/actions/dashboard'
import DashboradToggle from './DashboradToggle'
import ReviewGroupDataTable from '../dataTable/ReviewGroupDataTable'
import TableLoadingTemplate from '../loadingTemplate/tableLoadingTemplate/TableLoadingTemplate'

export default function WaitScrutinizeDep6({ config, onSettingChange = () => {} }) {
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [reviewTypeSearch, setReviewTypeSearch] = useState()

  let history = useHistory()

  useEffect(() => {
    if (config) {
      setSchema(settingSchema.data)
      setReviewTypeSearch(settingSchema.reviewTypeSearch)
    } else {
      handelGetSchemaDashboard(5, 1)
    }
  }, [])

  const handelGetSchemaDashboard = async (
    pagesize,
    pagenumber,
    projectCode,
    projectName,
    projectReviewType
  ) => {
    setIsLoading(true)
    // startLoading()
    console.log(pagesize, pagenumber, projectCode, projectName, projectReviewType)
    try {
      const response = await getDept6Scrutinize(
        pagesize,
        pagenumber,
        projectCode,
        projectName,
        projectReviewType
      )
      // console.log('WaitScrutinizeDep6 handelGetSchemaDashboard => ', JSON.stringify(response))
      setSchema(response.data)
      setReviewTypeSearch(response.reviewTypeSearch)
      // setSchema(mock.data)
      // setReviewTypeSearch(mock.reviewTypeSearch)
    } catch (e) {
      setError({})
    }
    // doneLoading()
    setIsLoading(false)
  }

  const onMultiSubmit = (selectList) => {
    console.log('WaitForScrutinize onSubmit', selectList)

    let idList = selectList.map((element) => {
      return element.id
    })

    sessionStorage.setItem('mutiReview', idList)
    sessionStorage.setItem('projectId', 'multi-reveiw')
    sessionStorage.setItem('param', '')

    return history.push({
      pathname: `${pathname.proposal.review.projectList}`,
      state: { selectId: idList },
    })
  }

  const onSingleSubmit = (obj) => {
    sessionStorage.setItem('projectId', obj.id)
    sessionStorage.setItem('param', '')
    // console.log('id', obj.ig)
    history.push(`${pathname.proposal.overview.overviewCoworker}`)
  }
  // filter

  if (!schema) {
    return <TableLoadingTemplate />
  }

  return (
    <>
      {schema && (
        <>
          {config && (
            <DashboradToggle
              onChange={onSettingChange}
              dashboradName={config.key}
              checked={config.show}
              style={{ marginTop: 20, marginBottom: -15 }}
            />
          )}

          <ProjectDataTable
            schema={schema}
            subName={{ enable: true }}
            multi={{ enable: true, buttonText: schema?.mutiButtonText }}
            single={{
              enable: true,
              buttonText: schema?.buttonText,
              // icon: schema?.singleIcon,
            }}
            onSingleSubmit={onSingleSubmit}
            onMultiSubmit={onMultiSubmit}
            pagination={true}
            onReload={handelGetSchemaDashboard}
            loading={isLoading}
            searchEnable={true}
            reviewTypeSearch={reviewTypeSearch}
            hideProjectType
            setting={config && true}
          >
            <hr />
            <ReviewGroupDataTable
              shaded={false}
              bordered={false}
              config={config}
              onSettingChange={onSettingChange}
            />
          </ProjectDataTable>

          {/* <ReviewGroupDataTable shaded={true} /> */}
        </>
      )}
    </>
  )
}

const settingSchema = {
  header: null,
  data: {
    header: 'โครงการที่รอกลั่นกรองเชิงประเด็น(สำนัก6)',
    projectCodeText: 'รหัสโครงการ',
    projectNameText: 'ชื่อโครงการ',
    projectTypeText: 'ประเภทโครงการ',
    projectReviewTypeText: 'วิธีการกลั่นกรอง',
    projectBudgetText: 'งบประมาณรวม',
    buttonText: 'กลั่นกรอง',
    mutiButtonText: 'ไปยังการกลั่นกรองหลายโครงการ',
    singleIcon: 'filter',
    totalSize: 1,
    values: [
      {
        id: '',
        projectCode: 'XX-XXXXX',
        projectName: {
          name: 'โครงการ XXXXX',
          statusName: 'สถานะ XXXXX',
        },
        projectBudget: '9,999,999.99',
        projectType: { value: 'โครงการ', label: '1' },
        projectReviewType: '1',
        projectReviewTypeLabel: 'เสนอกลั่นกรอง',
        multiDisabled: true,
      },
    ],
  },
  reviewTypeSearch: {
    label: 'วิธีการกลั่นกรอง',
    hint: 'เลือกวิธีการกลั่นกรอง',
    options: [
      { value: 1, label: 'เสนอกลั่นกรอง' },
      { value: 2, label: 'จัดประชุม' },
    ],
  },
}
